
import {fromEvent as observableFromEvent, Observable, Subscription} from 'rxjs';

import {takeUntil, map, mergeMap} from 'rxjs/operators';
/**
 * Created by eladd on 7/13/2017.
 */
import {Directive, ElementRef, Input, OnDestroy, OnInit} from "@angular/core";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {DeltaEvent} from "./deta.event";

export  {DeltaEvent} from "./deta.event";

@UntilDestroy()
@Directive({
	selector: '[cpTouchDrag]'
})
export class TouchDragDirective implements OnInit, OnDestroy {
	@Input() cpTouchDrag: string;

	constructor(protected elementRef: ElementRef) { }

	ngOnInit() {
		this.getTouchDrag().pipe(untilDestroyed(this)).subscribe(delta => {
		});
	}

	ngOnDestroy() {
	}

	protected getTouchDrag() {
		const element = this.elementRef.nativeElement;

		const mouseUp = observableFromEvent(document, 'touchend');
		const mouseMove = observableFromEvent(document, 'touchmove');
		const mouseDown = observableFromEvent(element, 'touchstart');

		return mouseDown.pipe(mergeMap((mouseDownEvent: TouchEvent) => {
			const startX = mouseDownEvent.changedTouches[0].clientX, startY = mouseDownEvent.changedTouches[0].clientY;
			let prevX = mouseDownEvent.changedTouches[0].clientX, prevY = mouseDownEvent.changedTouches[0].clientY;
			let isFirst = true;

			return mouseMove.pipe(map((mouseMoveEvent: TouchEvent) => {
				mouseMoveEvent.preventDefault();
				//mouseMoveEvent.stopPropagation();

				const deltaEvent = {
					left: mouseMoveEvent.changedTouches[0].clientX - startX,
					top: mouseMoveEvent.changedTouches[0].clientY - startY,
					offsetLeft: mouseMoveEvent.changedTouches[0].clientX - prevX,
					offsetTop: mouseMoveEvent.changedTouches[0].clientY - prevY,
					isFirst
				};

				isFirst = false;
				prevX = mouseMoveEvent.changedTouches[0].clientX;
				prevY = mouseMoveEvent.changedTouches[0].clientY;

				let scrollEl = this.cpTouchDrag ? element.querySelector(this.cpTouchDrag) : element;

				scrollEl.scrollTop -= deltaEvent.offsetTop;
				scrollEl.scrollLeft -= deltaEvent.offsetLeft;

				return deltaEvent;
			}),takeUntil(mouseUp),);
		}));
	}
}
